/* HAPPY EARTH ORGANIC — shared behaviour. Load with defer. */
(function(){
  'use strict';
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMarquee(root){
    (root||document).querySelectorAll('.heo-mq:not([data-heo-ready])').forEach(function(mq){
      mq.setAttribute('data-heo-ready','1');
      var t=mq.querySelector('.heo-mq__track'); if(!t)return;
      var c=t.cloneNode(true); c.setAttribute('aria-hidden','true'); mq.appendChild(c);
    });
  }
  function initRails(root){
    (root||document).querySelectorAll('[data-heo-rail-btn]:not([data-heo-ready])').forEach(function(b){
      b.setAttribute('data-heo-ready','1');
      b.addEventListener('click',function(){
        var r=document.getElementById(b.getAttribute('data-heo-rail-btn')); if(!r)return;
        r.scrollBy({left:Number(b.dataset.dir)*r.clientWidth*0.85,behavior:'smooth'});
      });
    });
  }
  function initReveal(root){
    var items=(root||document).querySelectorAll('[data-heo-count]:not([data-heo-ready]),[data-heo-fill]:not([data-heo-ready])');
    if(!items.length)return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting)return; var el=e.target;
        if(el.hasAttribute('data-heo-count')){
          var end=parseFloat(el.getAttribute('data-heo-count'))||0;
          if(reduce){el.textContent=end.toLocaleString();}
          else{var s=null;var step=function(t){if(s===null)s=t;var k=Math.min((t-s)/1400,1);el.textContent=Math.floor(end*(1-Math.pow(1-k,3))).toLocaleString();if(k<1)requestAnimationFrame(step);};requestAnimationFrame(step);}
        }
        if(el.hasAttribute('data-heo-fill'))el.style.width=el.getAttribute('data-heo-fill');
        io.unobserve(el);
      });
    },{threshold:.4});
    items.forEach(function(el){el.setAttribute('data-heo-ready','1');io.observe(el);});
  }

  /* Slider engine — used by hero-like sliders (philosophy). data-heo-slider wraps slides + dots + arrows */
  function initSliders(root){
    (root||document).querySelectorAll('[data-heo-slider]:not([data-heo-ready])').forEach(function(sl){
      sl.setAttribute('data-heo-ready','1');
      var slides=[].slice.call(sl.querySelectorAll('[data-heo-slide]'));
      var dotsWrap=sl.querySelector('[data-heo-dots]');
      var interval=parseInt(sl.getAttribute('data-heo-interval'),10)||7000;
      var i=0,timer;
      if(dotsWrap){slides.forEach(function(_,n){var b=document.createElement('button');b.setAttribute('role','tab');b.setAttribute('aria-label','Slide '+(n+1));if(n===0)b.setAttribute('aria-current','true');b.addEventListener('click',function(){go(n);play();});dotsWrap.appendChild(b);});}
      function go(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,x){s.classList.toggle('is-on',x===i);});if(dotsWrap){[].forEach.call(dotsWrap.children,function(b,x){x===i?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current');});}}
      function play(){if(reduce)return;clearInterval(timer);timer=setInterval(function(){go(i+1);},interval);}
      sl.querySelectorAll('[data-heo-arrow]').forEach(function(a){a.addEventListener('click',function(){go(i+parseInt(a.getAttribute('data-heo-arrow'),10));play();});});
      sl.addEventListener('mouseenter',function(){clearInterval(timer);});
      sl.addEventListener('mouseleave',play);
      go(0);play();
    });
  }

  /* Subscribe picker — thumbs + list + arrows switch a staged image panel */
  function initPickers(root){
    (root||document).querySelectorAll('[data-heo-picker]:not([data-heo-ready])').forEach(function(p){
      p.setAttribute('data-heo-ready','1');
      var slides=[].slice.call(p.querySelectorAll('[data-heo-pk-slide]'));
      var list=[].slice.call(p.querySelectorAll('[data-heo-pk-item]'));
      var thumbs=[].slice.call(p.querySelectorAll('[data-heo-pk-thumb]'));
      var idx=p.querySelector('[data-heo-pk-idx]');
      var cta=p.querySelector('[data-heo-pk-cta]');
      var i=0;
      function go(n){
        i=(n+slides.length)%slides.length;
        slides.forEach(function(s,x){s.classList.toggle('is-on',x===i);});
        list.forEach(function(l,x){x===i?l.setAttribute('aria-current','true'):l.removeAttribute('aria-current');});
        thumbs.forEach(function(t,x){x===i?t.setAttribute('aria-current','true'):t.removeAttribute('aria-current');});
        if(idx)idx.textContent=(i+1)+'/'+slides.length;
        if(cta&&list[i]){var lbl=list[i].getAttribute('data-heo-cta');if(lbl)cta.textContent=lbl;var href=list[i].getAttribute('data-heo-href');if(href)cta.setAttribute('href',href);}
      }
      thumbs.forEach(function(t,x){t.addEventListener('click',function(){go(x);});});
      list.forEach(function(l,x){l.addEventListener('click',function(){go(x);});});
      p.querySelectorAll('[data-heo-pk-arrow]').forEach(function(a){a.addEventListener('click',function(){go(i+parseInt(a.getAttribute('data-heo-pk-arrow'),10));});});
      go(0);
    });
  }

  /* Quick-buy modal (shoppable video) */
  var modal;
  function getModal(){if(modal)return modal;modal=document.getElementById('heo-quickbuy');return modal;}
  function open(d){var m=getModal();if(!m)return;m.querySelector('[data-qb-title]').textContent=d.title||'';m.querySelector('[data-qb-price]').innerHTML=d.price||'';var img=m.querySelector('[data-qb-img]');if(d.image){img.src=d.image;img.alt=d.title||'';img.hidden=false;}else{img.hidden=true;}m.querySelector('[data-qb-link]').href=d.url||'#';m.querySelector('[data-qb-variant]').value=d.variant||'';m.querySelector('[data-qb-qty]').value=1;var msg=m.querySelector('[data-qb-msg]');if(msg){msg.textContent='';msg.hidden=true;}m.classList.add('is-open');document.body.style.overflow='hidden';var c=m.querySelector('.heo-modal__close');if(c)c.focus();}
  function close(){var m=getModal();if(!m)return;m.classList.remove('is-open');document.body.style.overflow='';}
  function initQuickBuy(){
    document.addEventListener('click',function(e){
      var tr=e.target.closest('[data-heo-quickbuy]');
      if(tr){e.preventDefault();open({title:tr.dataset.title,price:tr.dataset.price,image:tr.dataset.image,url:tr.dataset.url,variant:tr.dataset.variant});return;}
      if(e.target.closest('[data-qb-close]')){close();return;}
      var step=e.target.closest('[data-qb-step]');
      if(step){var input=document.querySelector('[data-qb-qty]');input.value=Math.max(1,parseInt(input.value,10)+parseInt(step.dataset.qbStep,10));return;}
      var add=e.target.closest('[data-qb-add]');
      if(add){e.preventDefault();var m=getModal();var id=m.querySelector('[data-qb-variant]').value;var qty=parseInt(m.querySelector('[data-qb-qty]').value,10)||1;var msg=m.querySelector('[data-qb-msg]');add.disabled=true;add.dataset.label=add.textContent;add.textContent='Adding…';
        fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
        .then(function(r){return r.json();}).then(function(d){add.disabled=false;add.textContent=add.dataset.label;if(d.status){msg.hidden=false;msg.textContent=d.description||d.message||'Could not add to cart.';return;}msg.hidden=false;msg.textContent='Added to cart.';setTimeout(function(){window.location.href='/cart';},700);})
        .catch(function(){add.disabled=false;add.textContent=add.dataset.label;msg.hidden=false;msg.textContent='Something went wrong. Try again.';});
      }
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  function initLazyVideo(){
    document.addEventListener('click',function(e){
      var poster=e.target.closest('[data-heo-video]'); if(!poster)return;
      var wrap=poster.closest('.heo-vid'); if(!wrap||wrap.dataset.playing==='1')return;
      wrap.dataset.playing='1';
      var v=document.createElement('video');v.src=poster.dataset.heoVideo;v.muted=true;v.loop=true;v.playsInline=true;v.setAttribute('playsinline','');v.className='heo-vid__el';wrap.insertBefore(v,wrap.firstChild);v.play();poster.style.opacity='0';
    });
  }


  /* Best-seller card AJAX add-to-cart */
  function initCardAdd(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-heo-card-add]'); if(!btn)return;
      e.preventDefault();
      var card=btn.closest('[data-heo-card]');
      var qtyEl=card?card.querySelector('[data-heo-card-qty]'):null;
      var qty=qtyEl?Math.max(1,parseInt(qtyEl.value,10)||1):1;
      var id=btn.getAttribute('data-variant'); if(!id)return;
      var label=btn.textContent; btn.disabled=true; btn.textContent='Adding…';
      fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
      .then(function(r){return r.json();}).then(function(d){btn.disabled=false;if(d.status){btn.textContent='Unavailable';setTimeout(function(){btn.textContent=label;},1600);return;}btn.textContent='Added ✓';document.dispatchEvent(new CustomEvent('heo:cart:added'));setTimeout(function(){btn.textContent=label;},1600);})
      .catch(function(){btn.disabled=false;btn.textContent=label;});
    });
  }

  function boot(root){initMarquee(root);initRails(root);initReveal(root);initSliders(root);initPickers(root);}
  document.addEventListener('DOMContentLoaded',function(){boot(document);initQuickBuy();initLazyVideo();initCardAdd();});
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();
